import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'button[ngx-bottom-nav]',
  templateUrl: './bottom-nav-button.component.html',
  styleUrls: ['./bottom-nav-button.component.scss'],
  imports: [RouterLink],
  host: { '[class.label-hidden]': 'hideLabel()' }
})
export class BottomNavButtonComponent {
  /**
   * Determines whether labels of inactive buttons are hidden.
   */
  readonly hideLabel = input.required<boolean>();

  /**
   * The icon which is shown on this button.
   */
  readonly icon = input.required<string>();

  /**
   * The label which is shown on this button.
   */
  readonly label = input.required<string>();

  /**
   * Optional route for navigation buttons. When omitted, the button can be used
   * for actions that do not trigger routing.
   */
  readonly routerLink = input<string | null>(null);
  readonly exact = input<boolean>();
}
